import { gql } from '@apollo/client'

export const getAppConfig = gql`
query GetAppConfig {
  getAppConfig {
    enabled
    calendlyForLongDistance
    platform{
      name
      logo
      theme{
        primary
        primaryContrast
      }
      promoCode {
        editableByCustomer
        promoCode {
          id
          code
          type
          value
        }
      }
    }
  }
}
`
